export default "__VITE_ASSET__CzVpNesn__"